import React, { useEffect } from "react";
import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Categories from "./home-categories/Categories";
import Serving_love from "./serving-love/Serving_love";
import Why_choose_us from "./why-choose-us/Why_choose_us";
import Offer from "./offer/Offer";
import Special_features from "./special-features/Special_features";
import Download_app from "./download-app/Download_app";

function Home() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Banner />
      <Categories />
      <Serving_love />
      <Why_choose_us />
      <Offer />
      <Special_features />
      <Download_app />
    </>
  );
}

export default Home;
